import {
  ICanvasElementDrawArgs,
  ICanvasTextOptions,
  ACanvasTextElement
} from '@/models/marketingCenter/canvas';
import { printAtWithBreakStrategy } from '@/utils/canvas';

class TitleCanvasElement extends ACanvasTextElement {
  constructor(private readonly options: ICanvasTextOptions) {
    super();
  }

  defaultValues = {
    family: 'Inter',
    size: 22,
    lineHeight: 26,
    weight: 'bold',
    color: '#FFF',
    maxWidth: 110,
    align: 'left' as CanvasTextAlign,
    numberOfLines: undefined
  };

  render(
    container: HTMLDivElement,
    context: CanvasRenderingContext2D,
    args: ICanvasElementDrawArgs
  ) {
    const { defaultValues, options } = this;
    const { font = defaultValues, position, text: textOptions } = options;

    let text = args.title;

    if (textOptions) {
      text = typeof textOptions === 'string' ? textOptions : textOptions(args);
    }

    const {
      family = defaultValues.family,
      size = defaultValues.size,
      lineHeight = defaultValues.lineHeight,
      weight = defaultValues.weight,
      color = defaultValues.color,
      maxWidth = defaultValues.maxWidth,
      align = defaultValues.align,
      numberOfLines
    } = font;

    context.font = `${weight} ${size}px "${family}"`;

    this.renderNextYCoordAvailble = printAtWithBreakStrategy(
      (eachText, x, y, fontSize) => {
        const el = document.createElement('h3');
        el.textContent = eachText;

        el.style.position = 'absolute';
        el.style.width = `${maxWidth}px`;
        el.style.fontFamily = family;
        el.style.fontSize = `${fontSize || size}px`;
        el.style.fontWeight = `${weight}`;
        el.style.color = `${color}`;
        el.style.textAlign = align;
        el.style.top = `${y + 3}px`;
        el.style.left = `${x}px`;

        container.appendChild(el);
      },
      context,
      text,
      position.x,
      position.y + this.renderOffsetTop,
      lineHeight,
      maxWidth,
      numberOfLines
    );
  }

  async draw(context: CanvasRenderingContext2D, args: ICanvasElementDrawArgs) {
    const { defaultValues, options } = this;
    const { font = defaultValues, position, text: textOptions } = options;

    let text = args.title;

    if (textOptions) {
      text = typeof textOptions === 'string' ? textOptions : textOptions(args);
    }

    if (context && text) {
      const {
        family = defaultValues.family,
        size = defaultValues.size,
        lineHeight = defaultValues.lineHeight,
        weight = defaultValues.weight,
        color = defaultValues.color,
        maxWidth = defaultValues.maxWidth,
        align = defaultValues.align,
        numberOfLines
      } = font;

      context.textAlign = align as CanvasTextAlign;
      context.font = `${weight} ${size}px "${family}"`;
      context.fillStyle = color;
      const ctxTextWidth = context.measureText(text).width;
      const textWidth = Math.min(ctxTextWidth, maxWidth);

      const posY = position.y + size + this.offsetTop;
      let posX = position.x;

      if (align === 'center') {
        if (textWidth < maxWidth) {
          posX += maxWidth / 2;
        } else {
          posX += textWidth / 2;
        }
      }

      this.nextYCoordAvailble = printAtWithBreakStrategy(
        (text, x, y) => context.fillText(text, x, y),
        context,
        text,
        posX,
        posY,
        lineHeight,
        maxWidth,
        numberOfLines
      );
    }
  }
}

export default TitleCanvasElement;
